(function () {
    'use strict';
    angular.module('Services').service('ProviderLocationsTable', ProviderLocationsTable);
    ProviderLocationsTable.$inject = [
        'TableLiteFactory',
        'PopLockerService',
        '$uibModal'
    ];
    function ProviderLocationsTable(
        TableLiteFactory,
        PopLockerService,
        $uibModal
    ) {
        return function () {
            const tableData = {
                tableName: 'providerLocationsTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add Location',
                        tooltip: 'Click to add new location',
                        onClick: function () {
                            showLocationDetails();
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'Import Locations',
                        tooltip: 'Click to import locations',
                        onClick: function () {
                            // todo: add implementation code here
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'LOCKER ID',
                        viewName: 'lockerId'
                    },
                    {
                        label: 'LOCATION NAME',
                        viewName: 'locationName'
                    },
                    {
                        label: 'LOCATION ADDRESS',
                        viewName: 'locationAddress'
                    },
                    {
                        label: 'DROP-OFF/PICKUP',
                        viewName: 'dropOffPickup'
                    },
                    {
                        label: 'OPERATING HOURS',
                        viewName: 'operatingHours'
                    },
                    {
                        label: 'STATUS',
                        viewName: 'status'
                    },
                    {
                        label: 'ACTIONS',
                        viewName: 'actions'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: PopLockerService.getLocation,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: error => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    filterType: 'all'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data) { return null; }

                angular.forEach(data.content, function (row) {
                    row.lockerId = row.lockerId || 'N/A';
                    row.locationName = row.locationName || 'N/A';
                    row.dropOffPickup = row.dropOffPickup || 'N/A';

                    row.operatingHoursData = row.operatingHours;
                    row.operatingHours = {
                        type: 'multiLine',
                        list: row.operatingHours.map(itm => `${itm.startDay}-${itm.endDay} : ${itm.startTime} - ${itm.endTime}`),
                    };
                    const locationAddress = [];
                    locationAddress.push(row.addressLine2 ? `${row.addressLine1} ${row.addressLine1}` : `${row.addressLine1}`, `${row.location.name}, ${row.location.state.code} ${row.location.code}`)
                    row.locationAddress = {
                        type: 'multiLine',
                        list: locationAddress
                    }

                    row.status = row.status || 'N/A';
                    row.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: row.status ? 'ENABLE' : 'DISABLE',
                                class: row.status ? 'btn-green' : 'btn-danger',
                                action: data => {
                                    // todo: add implementation code here...
                                }
                            },
                            {
                                text: 'VIEW',
                                class: 'btn-primary',
                                action: data => {
                                    showLocationDetails(data);
                                }
                            },
                            {
                                text: 'DELETE',
                                class: 'btn-danger',
                                action: data => {
                                    // todo: add implementation code here
                                }
                            }
                        ]
                    };
                    tableData.data.push(row);
                });
            }

            function showLocationDetails(data) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/modal/provider-details-modal.html',
                    controller: 'ProviderLocationDetailsModalController',
                    controllerAs: 'vm',
                    keyboard: false,
                    backdrop: 'static',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        data: () => { return data; }
                    }
                }).result.then(function (data) {
                    if (!data) { return; }
                    sendRequest();
                });
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/pop-lockers/ProviderLocationsTable.js